// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VW7I","content":"styles_content__1QFZA","tableWrap":"styles_tableWrap__osPIC"};